import { Component, EventEmitter, Inject, Input, OnInit, Output, SimpleChanges } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { EmployeeRoleService } from '../../../core/services/employee/employee-role/employee-role.service'
import { OccurrenceService } from '../../../core/services/occurrence/occurrences/occurrences.service'
import { MatIconModule } from "@angular/material/icon";
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

@Component({
  selector: 'occurrence-edit',
  imports: [
    ReactiveFormsModule,
    MatButton,
    MatProgressSpinner,
    MatFormField,
    MatInput,
    MatLabel,
    MatIconModule
  ],
  templateUrl: './occurrence-edit.component.html',
  styleUrl: './occurrence-edit.component.scss',
  providers: [EmployeeRoleService],
  standalone: true,
})
export class OccurrenceEditComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private employeeRoleService: EmployeeRoleService,
    private snackbar: SnackbarCustomService,
    private occurrenceService: OccurrenceService,
    private dialogRef: MatDialogRef<OccurrenceEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any

  ) { }

  @Output() responseCreate = new EventEmitter()


  form: FormGroup = new FormGroup({})
  loading: boolean = false

  ngOnInit(): void {
    this.createForm()

    this.fillForm()
  }

  close() {
    this.dialogRef.close()
  }


  createItem() {
    this.loading = true
    const model = this.createModel()
    this.occurrenceService.createOccurrence(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseCreate.emit()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.form.reset()
      },
    })
  }

  editItem() {
    this.loading = true
    const descricao = this.createModel()
    const model = {
      id: this.data.id,
      descricao: descricao.descricao,
    }
    this.occurrenceService.editOccurrence(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseCreate.emit(response)
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.form.reset()
      },
    })
  }

  createModel() {
    return {
      descricao: this.form.controls['description'].value,
    }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      description: ['', [Validators.required]],
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['dataEdit'] && changes['dataEdit'].currentValue) {
      this.fillForm();
    }
  }

  fillForm() {
    this.form.controls['description'].setValue(this.data.descricao)
  }
}
